<template>
  <accordion-item
    :headline-level="'h3'"
    :title="$t('tripPlanner.settings.group.wayToStop')"
    :accordion-button-text="$t('tripPlanner.settings.group.wayToStop')"
    class="accordion__item--flat"
  >
    <template v-if="anyWayToStopSettingDiffersFromDefault" #accordion-header>
      <span>
        <span class="trip-setting--changed">{{ $t('tripPlanner.settings.settingChangedText') }}</span>
      </span>
    </template>
    <template #accordion-content>
      <div class="grid__2--tablet-portrait-up">
        <div class="grid__item">
          <custom-switch-input
            :legend="$t('tripPlanner.settings.group.wayToStop')"
            :hide-legend="true"
            :group="true"
            :switch-list="travelTypeData"
            @set-optionChanged="changeTravelType"
          />
        </div>
        <div class="grid__item">
          <custom-select
            :id="'walkingSpeed'"
            :label="$t('tripPlanner.settings.walkingSpeed.title')"
            :default-selected="false"
            :options="walkingSpeedData"
            @set-optionChanged="changeWalkingSpeed"
          />
          <custom-select
            :id="'pathToStop'"
            :label="$t('tripPlanner.settings.pathToStop.title')"
            :default-selected="false"
            :options="pathToStopData"
            @set-optionChanged="changePathToStop"
          />
        </div>
      </div>
    </template>
  </accordion-item>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { tripSettingsStore } from '@/stores/tripsettings'
import AccordionItem from '@/partials/accordion-item.vue'
import CustomSelect from '@/partials/_form/select.vue'
import CustomSwitchInput from '@/partials/_form/switch-input.vue'

export default {
  name: 'SettingWayToStop',
  components: {
    AccordionItem,
    CustomSelect,
    CustomSwitchInput
  },
  props: {
    travelType: {
      type: String || null,
      required: true
    },
    /*
    bikeOnStop: {
      type: Boolean,
      required: true
    },
    */
    walkingSpeed: {
      type: String || null,
      required: true
    },
    pathToStop: {
      type: String || null,
      required: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState(tripSettingsStore, [
      'anyWayToStopSettingDiffersFromDefault',
      'possibleOptions'
    ]),

    /**
     * Return array to render travelType Options.
     * @function travelTypeData
     */
    travelTypeData () {
      const array = []

      this.possibleOptions?.travelType.forEach((type) => {
        array.push({
          checked: (type === this.travelType),
          id: `travelType-${type}`,
          label: this.$t(`tripPlanner.settings.travelType.${type}`),
          type: 'radio',
          value: type
        })
      })

      return array
    },

    /**
     * Return array to render walkingSpeed Options.
     * @function walkingSpeedData
     */
    walkingSpeedData () {
      const array = []

      this.possibleOptions?.walkingSpeed.forEach((option) => {
        array.push({
          selected: (option === this.walkingSpeed),
          title: this.$t(`tripPlanner.settings.walkingSpeed.${option}`),
          value: option
        })
      })

      return array
    },

    /**
     * Return array to render pathToStop Options.
     * @function pathToStopData
     */
    pathToStopData () {
      const array = []

      this.possibleOptions?.pathToStop.forEach((option) => {
        array.push({
          selected: (option === this.pathToStop),
          title: this.$t(`tripPlanner.settings.pathToStop.${option}`),
          value: option
        })
      })

      return array
    }
  },
  watch: {
    travelType () {
      this.checkIfTheSettingDiffers('travelType')
    },
    /*
    bikeOnStop () {
      this.checkIfTheSettingDiffers('bikeOnStop')
    },
    */
    walkingSpeed () {
      this.checkIfTheSettingDiffers('walkingSpeed')
    },
    pathToStop () {
      this.checkIfTheSettingDiffers('pathToStop')
    }
  },
  beforeMount () {
    this.checkIfTheSettingDiffers('travelType')
    // this.checkIfTheSettingDiffers('bikeOnStop')
    this.checkIfTheSettingDiffers('walkingSpeed')
    this.checkIfTheSettingDiffers('pathToStop')
  },
  methods: {
    ...mapActions(tripSettingsStore, [
      'checkIfTemporarySettingDiffersFromDefault'
    ]),

    /**
     * Set travelType setting that the trip should use.
     * @function changeTravelType
     */
    changeTravelType () {
      this.$emit('travelTypeChanged', event.target.value)
    },

    /**
     * Set walkingSpeed setting that the trip should use.
     * @function changeWalkingSpeed
     */
    changeWalkingSpeed () {
      this.$emit('walkingSpeedChanged', event.target.value)
    },

    /**
     * Set pathToStop setting that the trip should use.
     * @function changePathToStop
     */
    changePathToStop () {
      this.$emit('pathToStopChanged', event.target.value)
    },

    /**
     * Check if the entered setting differs from its defaults.
     * @function checkIfTheSettingDiffers
     * @param {String} settingName - Name of the setting
     */
    checkIfTheSettingDiffers (settingName) {
      this.checkIfTemporarySettingDiffersFromDefault({
        settingName,
        settingValue: this[settingName]
      })
    }
  }
}
</script>
